import { gql } from '@apollo/client'

export const generateHmac = gql`
  query GenerateHmac {
    generateHmac
  }
`
